// filepath: d:\src\com.argodata.cdt.qd2.admin.muiconv\src\components\dialogs\ConfirmPromptHook.js
import React from "react";
import PropTypes from "prop-types";
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';


const ConfirmPromptHook = (props) => {
    // const onEscapeKey = (event) => {
    //     if (event.key === "Escape") {
    //         cancelOnClick();
    //     }
    // };

    const okOnClick = () => {
        props.ok();
    };

    const cancelOnClick = () => {
        props.cancel();
    };

    return (
        <Dialog
            open={props.open}
            onClose={props.close}
        >
            <DialogTitle id="confirm-prompt-title">
                {props.title}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="confirm-prompt-message">
                    {props.message}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button
                    key="confirm-prompt-ok"
                    id="confirm-prompt-ok"
                    variant="contained"
                    onClick={okOnClick}
                    primary="true"
                >OK</Button>

                <Button
                    key="confirm-prompt-cancel"
                    id="confirm-prompt-cancel"
                    variant="text"
                    onClick={cancelOnClick}
                >Cancel</Button>

            </DialogActions>
        </Dialog>
    );
};

ConfirmPromptHook.propTypes = {
    open: PropTypes.bool,
    title: PropTypes.string.isRequired,
    message: PropTypes.string,
    ok: PropTypes.func,
    cancel: PropTypes.func,
};

export default ConfirmPromptHook;